(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvDateInput', drvDateInput);

    /**
     * @ngdoc directive
     * @name drvDateInput
     * @description Date-only input with pop-up calendar for selection
     *
     * @param {string} value - A YYYY-MM-DD formatted string representing a date.
     * @param {object} field - An entity field object with properties such as 'HelpText', 'Mandatory', etc.
     */
    function drvDateInput() {
        return {
            templateUrl: 'app/fieldinput/date-input.tmpl.html',
            require: 'ngModel',
            scope: {},
            controller: drvDateInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                field: '='
            }
        };
    }

    drvDateInputCtrl.$inject = ['$scope'];

    function drvDateInputCtrl($scope) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.updateDateValue = updateDateValue;
        drvCtrl.showSuffix = showSuffix;
        Object.defineProperty(drvCtrl, 'invalid', {
            get: function () {
                return (!_.isNil(drvCtrl.field) && drvCtrl.field.Mandatory && (_.isNil(drvCtrl.value) || drvCtrl.value === ''));
            }
        });

        /*
         * drvCtrl.value aka ng-model is a YYYY-MM-DD string representation of the date.
         * drvCtrl.date is an internally used JS date object to support the input/lookup widget.
         *
         * When one changes, the other will be updated automatically using the appropriate function below.
         */

        $scope.$watch('drvCtrl.value', function () {
            if (!_.isNil(drvCtrl.value) && drvCtrl.value !== '') {
                // Neutralise time offset
                drvCtrl.date = moment.utc(drvCtrl.value).subtract(moment().utcOffset(), 'minutes').toDate();
            } else {
                drvCtrl.date = null;
            }
        });

        function updateDateValue() {
            if (!_.isNil(drvCtrl.date)) {
                drvCtrl.value = moment(drvCtrl.date).format('YYYY-MM-DD');
            } else {
                drvCtrl.value = '';
            }
        }

        function showSuffix() {
            return !_.isNil(drvCtrl.field) && !_.isNil(drvCtrl.field.Suffix) && drvCtrl.field.Suffix !== '';
        }
    }
})();